import { Box } from '@mui/material';
import ChartSection from '../shared/ChartSection';
import DualAxisLine from '../shared/DualAxisLine';
import useNivoTheme from '../shared/useNivoTheme';

export default function GDPVsSentiment({ data }) {
    const { colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    return (
        <ChartSection
            id="gdp-sentiment"
            title="Does congressional sentiment predict GDP growth?"
            subtitle="Quarterly buy/sell ratio vs GDP growth rate. Does Congress buy before the economy accelerates?"
        >
            <Box sx={{ height: 380 }}>
                <DualAxisLine
                    primary={{
                        id: 'Buy/Sell Ratio',
                        color: colors.primary,
                        unit: 'x',
                        data: data.map(d => ({ x: d.quarter, y: d.buy_sell_ratio })),
                    }}
                    secondary={{
                        id: 'GDP Growth %',
                        color: colors.success,
                        unit: '%',
                        data: data.map(d => ({ x: d.quarter, y: d.gdp_growth })),
                    }}
                    leftLegend="Buy/Sell Ratio"
                    rightLegend="GDP Growth %"
                />
            </Box>
        </ChartSection>
    );
}
